export const FOOTER_BANNER_TEXT = 'Already have an account?'
export const FOOTER_BANNER_CTA_TEXT = 'Sign in'
export const CONTINUE_TEXT = 'Create new list'
export const START_TRIAL_TEXT = 'Start Free trial'
export const TITLE = 'Your citation will be added to a new citation list'
export const INFO_TEXT = (attemptedStyle, currentGatedStyle) =>
  `Create your ${attemptedStyle} citation in a new list, or subscribe to add it to your current list and continue citing in ${currentGatedStyle} plus 7,000 more styles`
export const NEW_CITATION_LIST_MODAL_ID = '--new-citation-list-modal'
